/* ============================================================
   FREEPET Story - Page-specific script
   Target: assets/freepet-story.js
   Scope:
     1. Nav highlight (Story entry)
     2. Factory Film lazy load (click + viewport pause)
     3. Story FAQ accordion (single-open + ARIA sync)
   Dependencies: window.FP (transfer-safe: q1/qAll fallback + E-2 shim)
   Contract: SKILL-Core Section 5, SKILL-Engineering Section 1
   Stage B v1.0: transfer-safe helpers + E-2 shim + routes + i18n
   Note: Newsletter JS deleted per M-11 / RR-03 (zero JS on form)
   ============================================================ */

(function(){
'use strict';

var FP = window.FP = window.FP || {};

/* ------------------------------------------------------------
   Transfer-safe query helpers (home.js pattern, adjudication 10)
   Assemble helper names at runtime to avoid transfer corruption.
   Always define q1/qAll locally as source of truth.
   ------------------------------------------------------------ */
var S = '$';
var q1 = function(s, r){ return (r || document).querySelector(s); };
var qAll = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
if(!FP[S]){ FP[S] = q1; }
if(!FP[S + S]){ FP[S + S] = qAll; }

/* E-2 forward shim (adjudication 8):
   chrome.js uses FP.$$ and FP.$$$$$$ which were never defined.
   Assign the real two-sign function to these missing aliases.
   This is safe: FP.$$ is the canonical multi-query helper. */
if(!FP[S + S + S]){ FP[S + S + S] = FP[S + S]; }
if(!FP[S + S + S + S]){ FP[S + S + S + S] = FP[S + S]; }

/* ------------------------------------------------------------
   i18n keys (injected via window.FP.i18n from theme.liquid or section)
   JS cannot use Liquid t filter; fallback to English string.
   ------------------------------------------------------------ */
var I18N = FP.i18n = FP.i18n || {};
function t(key, fallback){
  return I18N[key] || fallback;
}

/* ------------------------------------------------------------
   1 - Nav highlight (Story entry)
   ------------------------------------------------------------ */
function initNavActive(){
  var page = document.documentElement.getAttribute('data-page');
  if(!page) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAP = {
    'story': root + 'pages/story'
  };
  var targetHref = MAP[page];
  if(!targetHref) return;

  requestAnimationFrame(function(){
    var links = qAll('.fp-nav-link, .fp-mmenu-link');
    links.forEach(function(a){
      if(a.getAttribute('href') === targetHref){
        a.classList.add('is-active');
        a.setAttribute('aria-current', 'page');
      }
    });
  });
}

/* ------------------------------------------------------------
   2 - Factory Film (21:9 click lazy load)
   data-src is populated from {{ section.settings.video_url }} (File 9).
   Empty data-src -> "Coming soon" fallback (D-13).
   ------------------------------------------------------------ */
function initStoryVideo(){
  var root = q1('[data-section="story-factory"]');
  if(!root) return;

  var card = root.querySelector('.fp-story-factory-card');
  var video = root.querySelector('.fp-story-factory-el');
  var btn   = root.querySelector('.fp-story-factory-btn');
  if(!card || !video || !btn) return;

  btn.addEventListener('click', function(){
    var src = video.getAttribute('data-src');
    if(!src){
      var label = btn.querySelector('span');
      if(label && !btn.dataset.busy){
        btn.dataset.busy = '1';
        var original = label.textContent;
        label.textContent = t('comingSoon', 'Coming soon');
        setTimeout(function(){ label.textContent = original; delete btn.dataset.busy; }, 1800);
      }
      return;
    }
    if(!video.getAttribute('src')){ video.setAttribute('src', src); video.load(); }
    card.classList.add('is-playing');
    video.muted = false;
    var p = video.play(); if(p && p.catch) p.catch(function(){});
  });

  video.addEventListener('ended', function(){ card.classList.remove('is-playing'); video.currentTime = 0; });
  video.addEventListener('error', function(){ video.style.display = 'none'; card.classList.remove('is-playing'); }, { passive:true });

  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      if(!en[0].isIntersecting && !video.paused) video.pause();
    }, { threshold:0.15 });
    io.observe(root);
  }
  document.addEventListener('visibilitychange', function(){
    if(document.hidden && !video.paused) video.pause();
  });
}

/* ------------------------------------------------------------
   3 - Story FAQ accordion
   Single-open + ARIA sync (is-open class + aria-expanded).
   ------------------------------------------------------------ */
function initStoryFaq(){
  var root = q1('[data-section="story-faq"]');
  if(!root) return;

  var items = qAll('.fp-story-faq-item', root);
  if(!items.length) return;

  items.forEach(function(item){
    var q = item.querySelector('.fp-story-faq-q');
    if(!q) return;
    q.addEventListener('click', function(){
      var wasOpen = item.classList.contains('is-open');
      items.forEach(function(s){
        s.classList.remove('is-open');
        var b = s.querySelector('.fp-story-faq-q');
        if(b) b.setAttribute('aria-expanded', 'false');
      });
      if(!wasOpen){
        item.classList.add('is-open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* ------------------------------------------------------------
   Boot
   ------------------------------------------------------------ */
function boot(){
  initNavActive();
  initStoryVideo();
  initStoryFaq();
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

})();